<template>
	<div class="px-3 py-2 flex items-center gap-3 hover:bg-gray-100 dark:hover:bg-gray-900 first:rounded-t last:rounded-b">
		<slot name="icon"/>
		<div class="grow flex flex-col">
			<p>{{ title }}</p>
			<p v-if="subtitle" class="text-sm text-gray-500">{{ subtitle }}</p>
			<div v-if="$slots.accessory" class="mt-1 flex">
				<slot name="accessory"/>
			</div>
		</div>
		<slot/>
	</div>
</template>
<script setup lang="ts">
import {defineProps} from 'vue'

defineProps<{
	title:string,
	subtitle?:string,
}>()
</script>
